import { aemAxiosInstance, apim } from "@/constants/api"
import qs from "qs"
import { getConfig } from "@/constants/config"
import { getSessionIdObjWithEpoc } from "@/utils/ApiUtil"
import { getStockEndPoint, searchPlpEndPoint } from "@/constants/index"

const getListOfParamsToFetch = persona => {
  const fl = [
    "id",
    "slug_s",
    "productName_s",
    "masterSKU_s",
    "sku_s",
    "Product_Category",
    "ProductBrandName_s",
    "productImages.url_ss",
    "SKUColorSwatchFilename_ss",
    "ProductDescriptionProductShort_s",
    `priceStartingAt.${persona}_d`,
    `discountedPriceStartingAt.${persona}_d`,
    `priceList.${persona}.saleOffer_s`,
    "Color.SKU.Details_ss",
    `Color.${persona}.Details_ss`,
    "ProductWebFeatures_ss",
    "ProductWebFeatures_s",
    "ProductIsExclusive_s",
    "RegionReleaseforShipment_dt",
    "title_s",
    "ProductNarrativeDescription_s",
    `priceList.${persona}.finalPrice_d`,
    "CustomerFacingBrand_s",
    "RegionBrandName_s",
    `priceList.${persona}.discountedPrice_d`,
    `priceList.${persona}.price_d`,
    "productImages.labelWithUrl_ss",
    "CustomerFacingSKU_s",
    "CrossSellRecommendationSKUList_ss",
  ]

  return fl.join(",")
}

const getProductDataFromSkuIds = async (
  persona = "GST",
  skus = [],
  brandName = "kohler"
) => {
  const fl = getListOfParamsToFetch(persona)
  const fq = skus.map(item => `sku_s:("${item}")`)

  const config = await getConfig()
  const language = config?.internationalization?.language ?? "en"
  const brand = config?.general?.siteName ?? ""
  return apim.get(`/search/plp`, {
    params: {
      fl,
      q: "*:*",
      fq: [fq.join(" "), `language_s:("${language}")`],
      collections: brand.toLowerCase(),
      profilename: `profile_${brand.toLowerCase()}_General`,
      rows: skus?.length ?? 10,
      // sessionId: getSessionIdObjWithEpoc(),
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: "repeat", encode: false })
    },
  })
}
export const getListOfRequiredSkus = async (
  persona = "GST",
  slug = "",
  sku = "",
  lwAppName = ""
) => {
  try {
    const fl = getListOfParamsToFetch(persona)
    const config = await getConfig()
    const language = config?.internationalization?.language ?? "en"
    const fq = `sku_s:("${sku}")`

    return apim.post(`search/pdp/${slug}`, {
      fl,
      q: "*:*",
      fq: `${fq} AND language_s:("${language}")`,
      collections: "kohler-india",
      profilename: `profile_kohler-india_General`,
      // sessionId: getSessionIdObjWithEpoc(),
    })
  } catch (err) {
    return {}
  }
}
export const getProductInventory = (skus = []) => {
  return apim.get(`${getStockEndPoint}/?sku=${skus}`)
}

const getZipCodes = jsonFileUrl => aemAxiosInstance.get(jsonFileUrl)

export const getProductBySkus = async (skus = [], fl = "") => {
  let query = ""
  skus.forEach((sku, i) => {
    query += `"${sku}"`
    if (i + 1 !== skus.length) query += ", "
  })

  const res = await apim.get(
    `${searchPlpEndPoint}?fl=${fl}&q=*:*&rows=10&collections=kohler-india&fq=sku_s:(${query})&profilename=profile_kohler-india_Search`
  )
  if (res && res.data) return res?.data?.response?.docs
  return []
}

export { getProductDataFromSkuIds, getZipCodes }
